import { createSelector } from '@ngrx/store';

import { homeItemDetailRootSelector } from '@app/modules/home-item-detail/store/selectors/home-item-detail.selector';
import { HomeItemDetailState } from '@app/modules/home-item-detail/store/state/home-item-detail.state';

export const getHomeItemDetailState = createSelector(
  homeItemDetailRootSelector,
  (state: HomeItemDetailState) => state.ui
);

